export const AD_CLIENT = "ca-pub-2045897741981582";

export const AD_SLOTS = {
    displayInline: "8742925212",
    newsInArticle: "1702608214",
    homeWomenInline: "1419537183",
    stickyBottom: "8551353528",
};
